const modalHtml = require("../../../../sharedHtml/modal.html");
const modalBodyHtml = require("./html/modalBody.html");
import _ from "underscore";
import {setElementsFromScope} from "../../../../utilities/selectorHelpers";
import render from "../../../../utilities/render";
import AsnStore from "../../../../stores/AsnStore";
let singleton;


export default function quotesInvalidationFactory(options){
  if(singleton){
    // singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new QuotesInvalidation(options);
    singleton.init();
    return singleton;
  }
}

const noop = (()=>{});




const elementsMap = {
  undoChangesBtn: ".undo-changes-btn",
  understandBtn: ".understand-btn"
}



function QuotesInvalidation(){
  const self = this;
  let done;
  self._element = $();
  const els = {};

  self.init = function(){
    setHtml();
    setElements();
    setWidgets();
    bindElements();
  }

  function getElement(){
    return self._element;
  }

  function setHtml(){
    self._element = $(render(
      modalHtml,
      {
        title: "Shipment Information Changed - Quote Removed",
        body: render(modalBodyHtml),
        footerBtns: `
          <a href="#" class="base-btn purple-btn understand-btn">I Understand</a>
        `
      }
    ));
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, getElement());
  }

  function setWidgets(){
    getElement().modal({backdrop: 'static', show: false});
  }

  function bindElements(){
    els.undoChangesBtn.on("click", onUndoChangesClick);
    els.understandBtn.on("click", onUnderstandClick);
  }

  function onUndoChangesClick(){
    console.log("undoing changes...and calling done");
    handleAfterQuoteSelectUndoChanges();
    hideModal();
    done(false);
  }

  function onUnderstandClick(){
    console.log("I understand...and calling done");
    resetQuotesNow();
    
    hideModal();
    done(true);
  }

  function resetQuotesNow(){
    AsnStore.resetQuotesRelatedFlags(getCurrentAsn(), {showQuotesRemovedBecauseInfoChangedMessage: true});
  }

  self.determineQuoteInvalidPrompt = function(doneFunc){
    done = doneFunc || noop;
    if(AsnStore.areQuotesInvalid(getCurrentAsn())){
      console.log("showing quote modal");

      // setTimeout(()=>{
      //   console.log("showed quote modal...now done and resetting stores");
      //   done(true);
      // },1000);
      showModal();
    }
    else{
      console.log('quotes are valid still.');
      done(true);
    }

  }

  function showModal(){
    getElement().modal("show");
  }

  function hideModal(){
    getElement().modal("hide");
  }

  function getCurrentAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/common/quotesInvalidationFactory/quotesInvalidationFactory.js